/** Well status → i18n key map, shared by the explorer and the record hub. */
import type { WellStatus } from "@api/types";
import type { MessageKey } from "@i18n/messages";

export const STATUS_KEY: Record<WellStatus, MessageKey> = {
  drilling: "status.drilling",
  completion: "status.completion",
  producing: "status.producing",
  suspended: "status.suspended",
};
